import { OjWebElement } from '@oracle/oraclejet-webdriver/elements';

/**
 * This is the base class for oj-c-date-picker WebElement, and is generated from the
 * component's metadata. Do not modify these contents since they'll be replaced
 * during the next generation.
 * Put overrides into the WebElements's subclass, DatePickerWebElement.ts.
 */
export class DatePickerWebElementBase extends OjWebElement {
  /**
   * Gets the value of <code>dayFormatter</code> property.
   *
   * @return The value of <code>dayFormatter</code> property.
   *
   */
  public getDayFormatter(): Promise<null> {
    return this.getProperty<null>('dayFormatter');
  }

  /**
   * Gets the value of <code>daysOutsideMonth</code> property.
   *
   * @return The value of <code>daysOutsideMonth</code> property.
   *
   */
  public getDaysOutsideMonth(): Promise<string> {
    return this.getProperty<string>('daysOutsideMonth');
  }

  /**
   * Gets the value of <code>monthAndYearPicker</code> property.
   *
   * @return The value of <code>monthAndYearPicker</code> property.
   *
   */
  public getMonthAndYearPicker(): Promise<string> {
    return this.getProperty<string>('monthAndYearPicker');
  }

  /**
   * Gets the value of <code>max</code> property.
   * The maximum selectable date, in ISO string format
   * @return The value of <code>max</code> property.
   *
   */
  public getMax(): Promise<string | null> {
    return this.getProperty<string | null>('max');
  }

  /**
   * Gets the value of <code>maxWidth</code> property.
   * Specifies the component style maxWidth.
   * @return The value of <code>maxWidth</code> property.
   *
   */
  public getMaxWidth(): Promise<number | string> {
    return this.getProperty<number | string>('maxWidth');
  }

  /**
   * Gets the value of <code>min</code> property.
   * The maximum selectable date, in ISO string format
   * @return The value of <code>min</code> property.
   *
   */
  public getMin(): Promise<string | null> {
    return this.getProperty<string | null>('min');
  }

  /**
   * Gets the value of <code>readonly</code> property.
   *
   * @return The value of <code>readonly</code> property.
   *
   */
  public getReadonly(): Promise<boolean> {
    return this.getProperty<boolean>('readonly');
  }

  /**
   * Gets the value of <code>todayButton</code> property.
   *
   * @return The value of <code>todayButton</code> property.
   *
   */
  public getTodayButton(): Promise<string> {
    return this.getProperty<string>('todayButton');
  }

  /**
   * Gets the value of <code>todayTimeZone</code> property.
   *
   * @return The value of <code>todayTimeZone</code> property.
   *
   */
  public getTodayTimeZone(): Promise<string> {
    return this.getProperty<string>('todayTimeZone');
  }

  /**
   * Sets the value of <code>value</code> property.
   *
   * @param value The value to set for <code>value</code>
   *
   */
  public changeValue(value: string | null): Promise<void> {
    return this.setProperty<string | null>('value', value);
  }

  /**
   * Gets the value of <code>value</code> property.
   *
   * @return The value of <code>value</code> property.
   *
   */
  public getValue(): Promise<string | null> {
    return this.getProperty<string | null>('value');
  }

  /**
   * Gets the value of <code>weekDisplay</code> property.
   *
   * @return The value of <code>weekDisplay</code> property.
   *
   */
  public getWeekDisplay(): Promise<string> {
    return this.getProperty<string>('weekDisplay');
  }

  /**
   * Gets the value of <code>width</code> property.
   * Specifies the component style width.
   * @return The value of <code>width</code> property.
   *
   */
  public getWidth(): Promise<number | string> {
    return this.getProperty<number | string>('width');
  }
}
